export default {
  refreshYourResults: 'Ergebnisse aktualisieren',
  weNeedTo:
    'Um euch über die jüngsten Preise und die aktuelle Verfügbarkeit zu informieren, müssen wir',
  refreshResults: 'die Ergebnisse aktualisieren.',
  okRefresh: 'Ok, aktualisieren',
}
